import React from 'react';
import ReactDOM from 'react-dom';
import { RecoilRoot } from 'recoil';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/styles/app.scss';
import { LoadingHookProvider } from 'hooks/useLoading';

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <LoadingHookProvider>
        <App />
      </LoadingHookProvider>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
